import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);
import Layout from '@/layout';
import dev from '@/views/test/development'


/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
    check: true|false            为真,则校验页面级权限
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [{
        path: '/screen-display',
        component: () =>
            import ('@/views/screen-display/index'),
        hidden: true
    }, {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [{
            path: '/redirect/:path(.*)',
            component: () =>
                import ('@/views/redirect/index')
        }]
    },
    {
        path: '/auth',
        component: () =>
            import ('@/views/auth/index'),
        hidden: true,
        children: [{
                name: "login",
                path: 'login',
                component: () =>
                    import ('@/views/auth/login'),
                hidden: true
            },
            {
                name: "register",
                path: 'register',
                component: () =>
                    import ('@/views/auth/register'),
                hidden: true
            },
            {
                name: "forgetPassword",
                path: 'forgetPassword',
                component: () =>
                    import ('@/views/auth/forgetPassword'),
                hidden: true
            },
            {
                name: "changePassword",
                path: 'changePassword',
                component: () =>
                    import ('@/views/auth/changePassword'),
                hidden: true
            }
        ]
    },
    {
        path: '/test',
        component: () =>
            import ("@/views/finance/bill_detail"),
        hidden: true
    },
    {
        path: '/auth-redirect',
        component: () =>
            import ('@/views/login/auth-redirect'),
        hidden: true
    },
    {
        path: '/404',
        component: () =>
            import ('@/views/error-page/404'),
        hidden: true
    },
    {
        path: '/401',
        component: () =>
            import ('@/views/error-page/401'),
        hidden: true
    },
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        children: [{
            path: 'dashboard',
            component: () =>
                import ('@/views/dashboard/index'),
            name: 'dashboard',
            meta: { title: '仪表盘', icon: 'dashboard', affix: true, check: false }
        }]
    },
    {
        path: '/icon',
        component: Layout,
        hidden: true,
        children: [{
            path: 'index',
            component: () =>
                import ('@/views/icons/index'),
            name: 'icon_index',
            meta: { title: '图标', icon: 'icon', noCache: false, check: true }
        }]
    },
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [{
        path: '/account',
        component: Layout,
        meta: { title: "个人中心", icon: "user" },
        children: [{
                path: 'basic',
                component: () =>
                    import ("@/views/account/basic"),
                name: 'account_basic',
                meta: { title: '我的资料', icon: 'user', noCache: false, check: true }
            },
            {
                path: 'message',
                component: () =>
                    import ("@/views/account/message"),
                name: 'account_message',
                meta: { title: '我的消息', icon: 'message', noCache: true, check: true }
            },
            // {
            //     path: 'task',
            //     component: () =>
            //         import ("@/views/account/task"),
            //     name: 'account_task',
            //     meta: { title: '我的审核', icon: 'task', noCache: true, check: true }
            // }
        ]
    },
    {
        path: "/product",
        component: Layout,
        meta: { title: "基础信息管理", icon: "component" },
        children: [{
                path: 'index',
                component: () =>
                    import ("@/views/product/index"),
                name: 'product_index',
                meta: { title: '价格管理', icon: 'pricem', noCache: true, check: true }
            },
            // {
            //     path: 'plan',
            //     component: () =>
            //         import ("@/views/product/product_plan"),
            //     name: 'product_plan',
            //     meta: { title: '销售计划设置', icon: 'chart', noCache: false, check: true }
            // },
            // {
            //     path: 'saler',
            //     component: () =>
            //         import ("@/views/product/product_saler"),
            //     name: 'product_saler',
            //     meta: { title: '销售人员绩效', icon: 'customer', noCache: false, check: true }
            // },

        ]
    },
    {
        path: "/plan",
        component: Layout,
        meta: { title: "计划管理", icon: "plan" },
        children: [{
                path: 'index',
                component: () =>
                    import ("@/views/order/order_list"),
                name: 'plan_index',
                meta: { title: '当前计划单', icon: 'plan', check: true }
            },
            {
                path: 'query',
                component: () =>
                    import ("@/views/order/order_query"),
                name: 'plan_query',
                meta: { title: '计划单查询', icon: 'search', check: true }
            },
            {
                path: 'history',
                component: () =>
                    import ("@/views/order/order_history_bak"),
                name: 'plan_history',
                meta: { title: '历史数据', icon: 'history', check: true }
            },
            {
                path: 'add',
                component: () =>
                    import ("@/views/order/add_order"),
                name: 'plan_add',
                meta: { title: '添加计划', icon: 'add', check: true }
            },
            {
                path: 'sort_list',
                component: () =>
                    import ('@/views/customer/sortlist'),
                name: 'sort_list',
                meta: { title: '车辆加塞', icon: 'list', noCache: false, check: true }
            },
            {
                path: 'detail/:id',
                component: () =>
                    import ("@/views/order/order_detail"),
                name: 'plan_detail',
                hidden: true,
                // meta: { title: '计划详情', icon: 'list',noCache: true}
                meta: { title: '计划详情', icon: 'list', check: true, activeMenu: '/plan/index' }
            },
        ]
    },
    {
        path: "/customer",
        component: Layout,
        meta: { title: "企业管理", icon: "customer" },
        children: [
            // {
            //         path: 'contract',
            //         component: () =>
            //             import ("@/views/contract/contract-managed"),
            //         name: 'contract_managed',
            //         meta: { title: '合同管理', icon: 'el-icon-document', noCache: false, check: true }
            //     },
            {
                path: 'company',
                component: () =>
                    import ('@/views/customer/company'),
                name: 'customer_company',
                meta: { title: '企业管理', icon: 'company', noCache: true, check: true }
            },
            {
                path: 'clientorder',
                component: () =>
                    import ('@/views/customer/client-order'),
                name: 'client_order',
                meta: { title: '企业计划管理', icon: 'el-icon-s-fold', noCache: true, check: true }
            },
            {
                path: 'clienthistory',
                component: () =>
                    import ('@/views/customer/client_history'),
                name: 'client_history',
                meta: { title: '企业历史数据', icon: 'el-icon-s-fold', noCache: true, check: true }
            },
            {
                path: 'client_detail/:id',
                component: () =>
                    import ("@/views/customer/client_detail"),
                name: 'client_detail',
                hidden: true,
                meta: { title: '计划详情', icon: 'list', check: true, activeMenu: '/customer/client' }
            },
            {
                path: 'add_company',
                component: () =>
                    import ('@/views/customer/add_company'),
                name: 'add_company',
                hidden: true,
                meta: { title: '添加企业信息', icon: 'add', noCache: true, activeMenu: '/customer/company', check: true }
            },
            {
                path: 'edit_company/:id',
                component: () =>
                    import ('@/views/customer/add_company'),
                name: 'edit_company',
                hidden: true,
                meta: { title: '修改企业信息', icon: 'edit', noCache: true, activeMenu: '/customer/company', check: true }
            },
            {
                path: 'user',
                component: () =>
                    import ("@/views/customer/user"),
                name: 'customer_user',
                meta: { title: '企业账号管理', icon: 'manyuser', noCache: true, check: true }
            },
            {
                path: 'financial_list',
                component: () =>
                    import ("@/views/customer/financial_list"),
                name: 'financial_list',
                meta: { title: '企业财务明细', icon: 'list', noCache: true, check: true }
            },
            {
                path: 'add_detail',
                component: () =>
                    import ("@/views/customer/financial_list"),
                name: 'add_detail',
                hidden: true,
                meta: { title: '企业财务明细', icon: 'list', activeMenu: '/customer/add_detail', noCache: true, check: true }
            }
        ]
    },

    {
        path: '/financial',
        component: Layout,
        meta: { title: "财务管理", icon: 'financial' },
        children: [{
                path: 'procurement',
                component: () =>
                    import ("@/views/procurement/add_procurement"),
                name: 'financial_procurement',
                meta: { title: '采购计划', icon: 'permission', noCache: true, check: true }
            },
            {
                path: 'detail/:id',
                component: () =>
                    import ("@/views/procurement/procurement_detail"),
                name: 'financial_detail',
                hidden: true,
                meta: { title: '计划详情', icon: 'list', check: true, activeMenu: '/financial/index' }
            },
            {
                path: 'financialhistory',
                component: () =>
                    import ('@/views/procurement/procurement_history'),
                name: 'financial_history',
                meta: { title: '采购历史数据', icon: 'el-icon-s-fold', noCache: true, check: true }
            },
            {
                path: 'materials',
                component: () =>
                    import ('@/views/materials/materials'),
                name: 'materials',
                meta: { title: '物资管理', icon: 'shopping', noCache: true, check: true }
            },
            {
                path: 'recon',
                component: () =>
                    import ("@/views/finance/bill_list"),
                name: 'financial_recon',
                meta: { title: '对账单管理', icon: 'recon', noCache: true, check: true }
            },
            {
                path: 'financial_statements',
                component: () =>
                    import ("@/views/procurement/financial_statements"),
                name: 'financial_statements',
                meta: { title: '财务报表', icon: 'recon', noCache: true, check: true }
            }
        ]
    }, {
        path: '/car',
        component: Layout,
        meta: { title: "车辆管理", icon: 'car' },
        children: [{
            path: 'car',
            component: () =>
                import ("@/views/vehicle/vehicle"),
            name: 'car',
            meta: { title: '车辆管理', icon: 'car', noCache: true, check: true }
        }]
    }, {
        path: '/reportCenter',
        component: Layout,
        meta: { title: "报表中心", icon: 'report' },
        children: [{
                path: 'base_report',
                component: () =>
                    import ("@/views/reportCenter/base_report"),
                name: 'base_report',
                meta: { title: '基础数据报表', icon: 'report3', noCache: true, check: true }
            }, {
                path: 'summary_table',
                component: () =>
                    import ("@/views/reportCenter/summary_table"),
                name: 'summary_table',
                meta: { title: '汇总表', icon: 'report1', noCache: true, check: true }
            }, {
                path: 'customer_balance_sheet',
                component: () =>
                    import ("@/views/reportCenter/customer_balance_sheet"),
                name: 'customer_balance_sheet',
                meta: { title: '企业余额表', icon: 'report2', noCache: true, check: true }
            }, {
                path: 'customer_cancels_schedule',
                component: () =>
                    import ("@/views/reportCenter/customer_cancels_schedule"),
                name: 'customer_cancels_schedule',
                meta: { title: '企业取消计划表', icon: 'report3', noCache: true, check: true }
            },
            {
                path: 'sales_statistics',
                component: () =>
                    import ("@/views/finance/sales_vital"),
                name: 'sales_statistics',
                meta: { title: '销售额统计', icon: 'vital', noCache: true, check: true }
            },
            {
                path: 'sales_num_statistics',
                component: () =>
                    import ("@/views/finance/sales_num"),
                name: 'sales_num_statistics',
                meta: { title: '销售量统计', icon: 'vital', noCache: true, check: true }
            },
            {
                path: 'load_volume_statisti',
                component: () =>
                    import ("@/views/reportCenter/loadVolumeStatistics"),
                name: 'load_volume_statisti',
                meta: { title: '装车量统计', icon: 'report5', noCache: true, check: true }
            }
        ]
    }, {
        path: '/article',
        component: Layout,
        meta: { title: "小程序管理", icon: "app" },
        children: [{
                path: 'index',
                component: () =>
                    import ("@/views/article/art_list"),
                name: 'article_index',
                meta: { title: '文章管理', icon: 'list', noCache: true, check: true }
            },
            {
                path: 'imap',
                component: () =>
                    import ("@/views/article/img_map"),
                name: 'imap',
                meta: { title: '轮播图管理', icon: 'imap', noCache: true, check: true }
            },
            {
                path: 'add',
                component: () =>
                    import ("@/views/article/add_art"),
                name: 'article_add',
                hidden: true,
                meta: { title: '添加文章', icon: 'add', noCache: true, check: true, activeMenu: '/article/index' }
            },
            {
                path: 'edit/:id',
                component: () =>
                    import ("@/views/article/add_art"),
                name: 'article_edit',
                hidden: true,
                meta: { title: '修改文章', icon: 'add', noCache: true, check: true, activeMenu: '/article/index' }
            }
        ]
    }, {
        path: '/options',
        component: Layout,
        meta: { title: "系统设置", icon: 'options' },
        children: [{
                path: '/userlist',
                component: () =>
                    import ('@/views/roleAndPermission/userlist'),
                name: 'auth_userlist',
                meta: { title: '用户列表', icon: 'peoples', noCache: true, check: true }
            },
            {
                path: '/role',
                component: () =>
                    import ('@/views/roleAndPermission/role'),
                name: 'auth_role',
                meta: { title: '用户组', icon: 'role', noCache: true, check: true }
            },
            {
                path: '/permission',
                component: () =>
                    import ('@/views/roleAndPermission/permission'),
                name: 'auth_permission',
                meta: { title: '权限管理', icon: 'permission', noCache: true, check: true }
            },
            // {
            //     path: '/feedback',
            //     component: () =>
            //         import ('@/views/option/feedback'),
            //     name: 'feedback_index',
            //     meta: { title: '用户反馈', icon: 'message', noCache: true, check: true }
            // },
            {
                path: '/params',
                component: () =>
                    import ("@/views/option/option"),
                name: 'params',
                hidden: true,
                meta: { title: '参数配置', icon: 'params', noCache: false, check: true }
            },
            {
                path: 'terminal',
                component: () =>
                    import ("@/views/management/management"),
                name: 'terminal',
                meta: { title: '终端配置', icon: 'el-icon-s-platform', noCache: true, check: true }
            }
        ]
    },

    // 404 page must be placed at the end !!!
    { path: '*', redirect: '/404', hidden: true }
];

const createRouter = () => new Router({
    mode: 'hash',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher // reset router
}

export default router
